import { Component, computed, inject } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfiguratorComponent } from './app.configurator';
import { LayoutService } from '../service/layout.service';
import { AuthService } from '../../Services/auth.service';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from '@/core/imports/primeng.imports';
import { BadgeModule } from 'primeng/badge';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    StyleClassModule,
    TooltipModule,
    ConfirmDialogModule,
    AppConfiguratorComponent,
    ButtonModule,
    BadgeModule 
  ],
  template: `
    <div class="flex w-screen h-full justify-between items-center">
      <div class="layout-topbar-logo-container ml-2">
        <button
          class="layout-menu-button layout-topbar-action"
          (click)="layoutService.onMenuToggle()"
        >
          <i class="pi pi-bars"></i>
        </button>
        <a class="layout-topbar-logo" routerLink="/">
          <div class="flex justify-center">
            <img src="./inviare.png" alt="" width="60" height="60" />
          </div>
          <span>Inviare</span>
        </a>
      </div>

      <div class="layout-topbar-actions flex">
        <div class="layout-config-menu">
          <button
            type="button"
            class="layout-topbar-action"
            (click)="toggleDarkMode()"
            pTooltip="Cambiar tema"
            tooltipPosition="bottom"
          >
            <i
              [ngClass]="{
                'pi ': true,
                'pi-moon': layoutService.isDarkTheme(),
                'pi-sun': !layoutService.isDarkTheme(),
              }"
            ></i>
          </button>
          <div class="relative">
            <button
              class="layout-topbar-action"
              pStyleClass="@next"
              enterFromClass="hidden"
              enterActiveClass="animate-scalein"
              leaveToClass="hidden"
              leaveActiveClass="animate-fadeout"
              [hideOnOutsideClick]="true"
              pTooltip="Paleta Colores"
              tooltipPosition="bottom"
            >
              <i class="pi pi-palette"></i>
            </button>
            <app-configurator />
          </div>
          <div class="relative">
            <p-button 
              [rounded]="true"
              (click)="confirmExit()"
              pTooltip="Cerrar Sesión"
              tooltipPosition="bottom"
            >  
              <i class="pi pi-user"></i>           
              <span class="font-bold">{{ (nameUser().split(' ')[0] | slice:0:15) + (nameUser().split(' ')[0].length > 15 ? '...' : '') }} </span> 
              <p-badge class="capitalize" [value]="nameRol()" severity="secondary" />
            </p-button>
          </div>
        </div>
      </div>
    </div>
    <p-confirmDialog></p-confirmDialog>
  `,
  providers: [ConfirmationService],
})
export class AppTopbarComponent {
  items!: MenuItem[];
  private authService = inject(AuthService);
  private confirmationService = inject(ConfirmationService);

  nameUser = computed(() => this.authService?.getCurrentUser()?.Nombre ?? '') ;
  nameRol = computed(() => this.authService?.getCurrentUser()?.NombreRol ?? '') ;
  
  constructor(public layoutService: LayoutService) {}

  toggleDarkMode() {
    this.layoutService.layoutConfig.update((state) => ({
      ...state,
      darkTheme: !state.darkTheme,
    }));
  }
  confirmExit() {
    this.confirmationService.confirm({
      header: 'Confirmación',
      message: '¿Desea cerrar sesión?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sí',
      rejectLabel: 'No',
      accept: () => {
        this.exit();
      },
    });
  }
  exit() {
    this.authService.logoutStorage();
  }
}
